import { InvestorDetailsLegalEntityAssetClassTargetsQuery } from '@/__generated__/graphql';
import { GroupedIcon } from '@/assets/icons/info-icons/groupedIcon';
import { PlusIcon } from '@/assets/icons/info-icons/plusIcon';
import FormattingTooltip from '@/components/basicComponents/tooltip/dollarsTooltip';
import { themeVar } from '@/styles/theme';
import { useState } from 'react';
import styled from 'styled-components';

const getCapacityCellContent = (
  row:
    | InvestorDetailsLegalEntityAssetClassTargetsQuery['legalEntity']['assetClassTargets'][number]
    | InvestorDetailsLegalEntityAssetClassTargetsQuery['legalEntity']['assetClassTargets'][number]['subAssetClasses'][number],
  hasCommitmentPlans: boolean,
  targetOCRatio: number | null,
  targetSubAssetClasses: boolean
) => {
  // if (targetSubAssetClasses && 'subAssetClasses' in row) {
  //   const subAssetClassesSum = row.subAssetClasses.reduce((sum, subAssetClass) => {
  //     // Use remainingPacingTarget if available, otherwise use capacity
  //     const valueToAdd =
  //       subAssetClass.pacingTarget?.remainingPacingTarget !== undefined ? subAssetClass.pacingTarget.remainingPacingTarget : subAssetClass.capacity;

  //     return sum + (valueToAdd || 0);
  //   }, 0);

  //   return <FormattingTooltip>{subAssetClassesSum}</FormattingTooltip>;
  // }

  if (hasCommitmentPlans && targetOCRatio === null) {
    return (
      <>
        {row.illiquid ? (
          <FormattingTooltip>{row?.pacingTarget?.remainingPacingTarget}</FormattingTooltip>
        ) : (
          <FormattingTooltip>{row?.capacity}</FormattingTooltip>
        )}
      </>
    );
  }

  if (!hasCommitmentPlans && targetOCRatio === null) {
    return <>{row.illiquid ? <>--</> : <FormattingTooltip>{row?.capacity}</FormattingTooltip>}</>;
  }

  return (
    <>
      <FormattingTooltip>{row.capacity}</FormattingTooltip>
    </>
  );
};

interface AssetClassRowProps {
  assetClass: InvestorDetailsLegalEntityAssetClassTargetsQuery['legalEntity']['assetClassTargets'][number];
  targetSubAssetClasses: boolean;
  hasCommitmentPlans: boolean;
  targetOCRatio: number | null;
}

export const AssetClassRow = ({ assetClass, targetSubAssetClasses, hasCommitmentPlans, targetOCRatio }: AssetClassRowProps) => {
  const [showSubAssetClass, setShowSubAssetClass] = useState(false);

  return (
    <>
      <SimpleTableRow>
        <RowItem>
          {targetSubAssetClasses && assetClass.subAssetClasses ? (
            <PlusIconWrapper onClick={() => setShowSubAssetClass(!showSubAssetClass)}>
              <PlusIcon fill={themeVar('font.base')} />
            </PlusIconWrapper>
          ) : (
            <></>
          )}
          {assetClass.name}
        </RowItem>
        <RowItem isBold={Boolean(targetSubAssetClasses && assetClass.subAssetClasses)}>{assetClass.percentage?.toFixed(2)}%</RowItem>
        <RowItem isBold={Boolean(targetSubAssetClasses && assetClass.subAssetClasses)}>
          {getCapacityCellContent(assetClass, hasCommitmentPlans, targetOCRatio, targetSubAssetClasses)}
        </RowItem>
      </SimpleTableRow>
      {targetSubAssetClasses && showSubAssetClass && (
        <>
          {assetClass.subAssetClasses.map((subAssetClass) => (
            <SimpleTableRow key={subAssetClass.id}>
              <RowItem>
                <GroupIconWrapper>
                  <GroupedIcon width={10} height={10} />
                </GroupIconWrapper>
                {subAssetClass.name}
              </RowItem>
              <RowItem>{subAssetClass.percentage?.toFixed(2)}%</RowItem>
              <RowItem>{getCapacityCellContent(subAssetClass, hasCommitmentPlans, targetOCRatio, targetSubAssetClasses)}</RowItem>
            </SimpleTableRow>
          ))}
        </>
      )}
    </>
  );
};

const RowItem = styled.div<{ isBold?: boolean }>`
  width: 33%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 6px;
  font-family: Blinker, serif;
  font-size: 16px;
  font-weight: ${({ isBold }) => (isBold ? 600 : 400)};
  line-height: 22px;
  letter-spacing: 0;
  color: ${themeVar('font.base')};
`;

const PlusIconWrapper = styled.div`
  padding: 5px;
  cursor: pointer;
`;

const GroupIconWrapper = styled.div`
  padding: 5px;
  position: relative;
  top: -5px;
  left: 5px;
`;

const SimpleTableRow = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  background-color: ${({ theme }) => theme.layer[1]};
  margin-bottom: 3px;
  justify-content: space-between;
  border-radius: 4px;
  padding: 5px 24px;
  position: relative;
`;
